import { API_BASE_URL } from "../urls.api";

export const GET_CUSTOMER_BY_USER_ID = `${API_BASE_URL}/customers/user`;

export const UPDATE_CUSTOMER = `${API_BASE_URL}/customers`;

export const getCustomerServiceContractsByUserIdUrl = (userId?: string) =>
  `${API_BASE_URL}/customers/service-contracts/user${userId ? `?userId=${userId}` : ""}`;
